import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import { Dropdown } from "semantic-ui-react";
import { placeHolderImage } from "../../../utils/utils";

const AdvocatesReminderDropdown = (props) => {
  const [advocates, setAdvocates] = useState([]);

  useEffect(() => {
    const data = props.advocates;

    if (data) {
      const savingArray = [];
      data.forEach((e, index) => {
        const saving = {
          key: index,
          text: e.name,
          value: e.id,
          image: {
            avatar: true,
            src: e.thumbnail || placeHolderImage,
          },
          email: e.email,
          phone: e.phone,
        };
        savingArray.push(saving);
      });

      setAdvocates(savingArray);
    }
  }, [props.advocates]);

  const handleDropdownChange = (e, data) => {
    const selected = data.value.map((e) => {
      let data = {};
      advocates.forEach((ad) => {
        if (ad.value === e) {
          data = ad;
        }
      });

      return {
        id: data?.value,
        email: data?.email,
        contact1: data?.phone || null,
        contact2: null,
        contact3: null,
      };
    });
    props.onChange(selected);
  };

  return (
    <Dropdown
      onChange={handleDropdownChange}
      options={advocates}
      search
      clearable
      multiple
      loading={!isLoaded(props.advocates)}
      placeholder="Select Advocates"
      name="advocates"
      selection
      fluid
    />
  );
};

const mapStateToProps = (state) => {
  const advocatesData = state.firestore.ordered.advocates;
  const advocates = [];

  if (advocatesData && advocatesData.length > 0) {
    advocatesData.forEach((a) => {
      const data = {};
      data.id = a.id;
      data.name = a.name;
      data.email = a.email;
      if (a.phone) data.phone = a.phone;
      data.thumbnail = a.thumbnailUrl;

      advocates.push(data);
    });
  }
  return {
    advocates,
    adding: state.reminder.adding,
    error: state.reminder.error,
    added: state.reminder.add,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: "advocates", orderBy: ["name"] }])
)(AdvocatesReminderDropdown);
